export class EstadoDeCuentaGlobal {
    constructor(
        public FAC_NUM_FAC?: number,
        public RAM_COD?: string,
        public ASE_COD?: number,
        public POL_COD?: string,
        public DET_REF?: string,
        public PRIMA?: number,
        public DIAS?: number,
        public UNI_COD?: number,
        public SEG_COD?: number,
        public RAM_NOM?: string,
        public ASE_NOM?: string,
        public Mas30?: number,
        public De16A30?: number,
        public De8A15?: number,
        public De0A7?: number,
        public Descripcion?: string
    ) { }
}
export class EstadoDeCuentaPorSegmento {
    constructor(
        public Segmento?: string,
        public RAM_COD?: string,
        public ASE_COD?: number,
        public Ramo?: string,
        public Aseguradora?: string,
        public Prima?: number,
        public Mas30?: number,
        public De16A30?: number,
        public De8A15?: number,
        public De0A7?: number,
        public Dias?: number
    ) { }
}
export class EstadosDeCuentaCliente {
    constructor(
        public EstadoDeCuentaXFactura?: EstadoDeCuentaGlobal[],
        public EstadoDeCuentaPatrimonialXRamo?: EstadoDeCuentaPorSegmento[],
        public EstadoDeCuentaFianzasPymesXRamo?: EstadoDeCuentaPorSegmento[],
        public EstadoDeCuentaVidaAsistenciaXRamo?: EstadoDeCuentaPorSegmento[],
        public EstadoDeCuentaPatrimonial?: EstadoDeCuentaPorSegmento,
        public EstadoDeCuentaFianzasPymes?: EstadoDeCuentaPorSegmento,
        public EstadoDeCuentaVidaAsistencia?: EstadoDeCuentaPorSegmento,
    ) { }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/entities/estado_de_cuenta_entity.ts